var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "card",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "10" } },
            [
              _c(
                "b-form",
                {
                  staticClass: "row",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.doFilter($event)
                    }
                  }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("el-input", {
                        staticClass: "input-primary",
                        attrs: { placeholder: "Filter By Name", clearable: "" },
                        model: {
                          value: _vm.tableFilter.name,
                          callback: function($$v) {
                            _vm.$set(_vm.tableFilter, "name", $$v)
                          },
                          expression: "tableFilter.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "1" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" }
                      },
                      [
                        _c("font-awesome-icon", { attrs: { icon: "search" } }),
                        _vm._v(" Search")
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c("create-new-data", {
                attrs: {
                  "data-url": "/pengaturan/supplier/create",
                  clearfix: false
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "12 mb-1" } }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center h-100" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.fakeTableFilter.is_active,
                      callback: function($$v) {
                        _vm.$set(_vm.fakeTableFilter, "is_active", $$v)
                      },
                      expression: "fakeTableFilter.is_active"
                    }
                  },
                  [_vm._v("Active Only")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("paginated-table", {
        ref: "dataTable",
        attrs: {
          "can-delete": false,
          "param-no-uuid": true,
          "active-url": _vm.apiUrl,
          "data-url": _vm.apiUrl,
          "data-key": _vm.dataKey,
          "data-columns": _vm.columns,
          "data-params": ["is_active", "name"]
        },
        scopedSlots: _vm._u([
          {
            key: "content_created_by",
            fn: function(defaultSlotScope) {
              return [
                _vm._v(
                  "\n      " + _vm._s(defaultSlotScope.rowData.created_by.name)
                )
              ]
            }
          },
          {
            key: "content_last_updated_by",
            fn: function(defaultSlotScope) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(defaultSlotScope.rowData.last_updated_by.name)
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a932b730", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a932b730","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Settings/Suppliers/Index.vue
// module id = bZBg
// module chunks = 4